// O CSV da aba Números, montado do mesmo JSON que a tela mostra (PLAN D2): "o
// CSV tem exatamente os números da tela" vale por construção, sem segunda
// consulta. Os números vão crus, como o servidor os manda (contagem inteira,
// tempo em segundos), e o "sem dado" (null) vira célula vazia, nunca 0.

// O texto de cada número, na tela e no CSV.
export const FIELDS = {
  new_conversations: 'ATENDIMENTO_REPORTS.NUMBERS.FIELDS.NEW_CONVERSATIONS',
  resolved: 'ATENDIMENTO_REPORTS.NUMBERS.FIELDS.RESOLVED',
  received: 'ATENDIMENTO_REPORTS.NUMBERS.FIELDS.RECEIVED',
  ai_messages: 'ATENDIMENTO_REPORTS.NUMBERS.FIELDS.AI_MESSAGES',
  human_messages: 'ATENDIMENTO_REPORTS.NUMBERS.FIELDS.HUMAN_MESSAGES',
  human_messages_support:
    'ATENDIMENTO_REPORTS.NUMBERS.FIELDS.HUMAN_MESSAGES_SUPPORT',
  external_bot_messages:
    'ATENDIMENTO_REPORTS.NUMBERS.FIELDS.EXTERNAL_BOT_MESSAGES',
  dispatches_sent: 'ATENDIMENTO_REPORTS.NUMBERS.FIELDS.DISPATCHES_SENT',
  dispatches_delivered:
    'ATENDIMENTO_REPORTS.NUMBERS.FIELDS.DISPATCHES_DELIVERED',
  first_response_any: 'ATENDIMENTO_REPORTS.NUMBERS.FIELDS.FIRST_RESPONSE_ANY',
  first_response_human:
    'ATENDIMENTO_REPORTS.NUMBERS.FIELDS.FIRST_RESPONSE_HUMAN',
  wait: 'ATENDIMENTO_REPORTS.NUMBERS.FIELDS.WAIT',
  resolution: 'ATENDIMENTO_REPORTS.NUMBERS.FIELDS.RESOLUTION',
};

// As contagens, na ordem da tela. As do suporte Powerbizz já estão dentro das
// de pessoas: vão no CSV com o nome "das quais", e na tela só como dica.
export const COUNTS = [
  'new_conversations',
  'resolved',
  'received',
  'ai_messages',
  'human_messages',
  'human_messages_support',
  'external_bot_messages',
  'dispatches_sent',
  'dispatches_delivered',
];

// Os tempos e o que cada um traz: mediana, média e amostras e, na 1ª resposta,
// as que ficaram sem resposta.
export const TIMES = {
  first_response_any: ['p50', 'avg', 'n', 'unanswered'],
  first_response_human: ['p50', 'avg', 'n', 'unanswered'],
  wait: ['p50', 'avg', 'n'],
  resolution: ['p50', 'avg', 'n'],
};

const STATS = {
  p50: 'ATENDIMENTO_REPORTS.NUMBERS.CSV.P50',
  avg: 'ATENDIMENTO_REPORTS.NUMBERS.CSV.AVG',
  n: 'ATENDIMENTO_REPORTS.NUMBERS.CSV.N',
  unanswered: 'ATENDIMENTO_REPORTS.NUMBERS.CSV.UNANSWERED',
};

// O nome do balde: o dia (dd/mm), "semana de dd/mm" ou o mês (mm/aaaa). O
// servidor manda só os números, e a palavra fica com a tela.
export const bucketLabel = (t, grain, row) =>
  grain === 'semana'
    ? t('ATENDIMENTO_REPORTS.NUMBERS.WEEK_OF', { day: row.label })
    : row.label;

// Texto com vírgula, aspas ou quebra de linha vai entre aspas, com as aspas
// dobradas (RFC 4180).
export const csvCell = value => {
  if (value === null || value === undefined) return '';
  const text = String(value);
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

const toCsv = rows => rows.map(row => row.map(csvCell).join(',')).join('\n');

const values = row => [
  ...COUNTS.map(key => row[key]),
  ...Object.entries(TIMES).flatMap(([key, stats]) =>
    stats.map(stat => row[key][stat])
  ),
];

// Uma linha por balde e a do total por último, cada uma com o primeiro e o
// último dia. A mediana do total é a do servidor, e não sai dos baldes.
export const numerosCsv = (report, t) =>
  toCsv([
    [
      t('ATENDIMENTO_REPORTS.NUMBERS.TABLE.PERIOD'),
      t('ATENDIMENTO_REPORTS.NUMBERS.CSV.FROM'),
      t('ATENDIMENTO_REPORTS.NUMBERS.CSV.TO'),
      ...COUNTS.map(key => t(FIELDS[key])),
      ...Object.entries(TIMES).flatMap(([key, stats]) =>
        stats.map(stat =>
          t('ATENDIMENTO_REPORTS.NUMBERS.CSV.STAT', {
            metric: t(FIELDS[key]),
            stat: t(STATS[stat]),
          })
        )
      ),
    ],
    ...report.series.map(row => [
      bucketLabel(t, report.grain, row),
      row.bucket,
      row.until,
      ...values(row),
    ]),
    [
      t('ATENDIMENTO_REPORTS.NUMBERS.TOTAL'),
      report.period.since,
      report.period.until,
      ...values(report.totals),
    ],
  ]);

// Os dois mapas de calor, uma linha por casa, no fuso da resposta. O dia da
// semana vai pelo nome e pelo número (0 é domingo). `dayName(dow)` dá o nome.
export const mapaCsv = (report, t, dayName) =>
  toCsv([
    [
      t('ATENDIMENTO_REPORTS.NUMBERS.CSV.WEEKDAY'),
      t('ATENDIMENTO_REPORTS.NUMBERS.CSV.DOW'),
      t('ATENDIMENTO_REPORTS.NUMBERS.CSV.HOUR', {
        timezone: report.timezone,
      }),
      t('ATENDIMENTO_REPORTS.NUMBERS.FIELDS.NEW_CONVERSATIONS'),
      t('ATENDIMENTO_REPORTS.NUMBERS.FIELDS.RESOLVED'),
    ],
    ...report.cells.map(cell => [
      dayName(cell.dow),
      cell.dow,
      cell.hour,
      cell.new_conversations,
      cell.resolved,
    ]),
  ]);
